import { render } from "./MainTwoDepthItem.vue?vue&type=template&id=7c764ca2&scoped=true"
import script from "./MainTwoDepthItem.vue?vue&type=script&lang=js"
export * from "./MainTwoDepthItem.vue?vue&type=script&lang=js"

import "./MainTwoDepthItem.vue?vue&type=style&index=0&id=7c764ca2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c764ca2"]])

export default __exports__